import { styled } from "styled-components";

export const CategoryImage = styled.img`
  width: 100%;
  height: 100%;

  padding: 20px;
  margin-bottom: -10px;
`;
